
































import Vue from "vue";
export default Vue.extend({
  name: "BlockContainer",
  methods: {
    addInterval() {
      this.$emit("interval:add");
    },
    removeInterval() {
      this.$emit("interval:remove");
    },
  },
});
